// @ts-nocheck
import React, { useEffect, useState } from 'react';
import icons from '../../../constants/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export interface RequestStatusLabelProps {
  requestStatus?: any;
  isWaitingForKeys?: boolean;
  isUpdateInProgress?: boolean;
  isDownloaded?: boolean;
  isEmailSent?: boolean;
  noBadge?: boolean;
}

export function RequestStatusLabel({
  requestStatus,
  isWaitingForKeys,
  isUpdateInProgress,
  isDownloaded,
  isEmailSent,
  noBadge,
}: RequestStatusLabelProps) {
  const { t } = useTranslation();
  let getLabelClasses = (
    requestStatus,
    isWaitingForKeys,
    isUpdateInProgress
  ) => {
    if (requestStatus?.isDeclined || requestStatus?.isWithdrawn)
      return 'bg-danger';

    if (isUpdateInProgress) return 'bg-info';

    if (requestStatus?.isAuthorised && isWaitingForKeys) return 'bg-info';

    if (requestStatus?.isAuthorised) return 'bg-success';

    if (requestStatus?.isPending) return 'bg-info';
    if (requestStatus?.name === 'Keys Ordered') return 'bg-info';

    return 'bg-info';
  };

  const [name, setName] = useState();
  useEffect(() => {
    if (isUpdateInProgress) {
      setName(t('Processing...'));
    } else if (requestStatus?.isAuthorised && isWaitingForKeys) {
      setName(t('Pending keys'));
    } else {
      setName(requestStatus?.name);
    }
  }, [requestStatus, isUpdateInProgress, isWaitingForKeys, t]);

  const showEmailSentLabel =
    !!isEmailSent &&
    requestStatus?.isAuthorised &&
    !isWaitingForKeys &&
    !isDownloaded;

  let nameTranslation =
    t(t(name)) +
    (isDownloaded
      ? ' ' + t('(downloaded)')
      : showEmailSentLabel
      ? ' ' + t('(email(s) sent)')
      : '');

  return requestStatus ? (
    noBadge ? (
      <span title={nameTranslation}>
        {nameTranslation}
        {isDownloaded ? (
          <FontAwesomeIcon icon={icons.DOWNLOADED} className="ms-2" />
        ) : (
          ''
        )}
      </span>
    ) : (
      <span
        className={`badge ${getLabelClasses(
          requestStatus,
          isWaitingForKeys,
          isUpdateInProgress
        )}`}
        title={nameTranslation}
      >
        {nameTranslation}
        {isDownloaded ? (
          <FontAwesomeIcon icon={icons.DOWNLOADED} className="ms-2" />
        ) : (
          ''
        )}
      </span>
    )
  ) : (
    <span className={`badge bg-multiple`}>{t('Multiple')}</span>
  );
}
